export default __webpack_public_path__ + "assets/images/3.ddf650.webp";